export const IMAGES = {
    heroTeacher:
        "https://images.unsplash.com/photo-1758876202726-bdb6c1272152?q=85&w=1200&auto=format&fit=crop",
    ukStudents:
        "https://images.unsplash.com/photo-1595878549954-cbc4a72e7cd2?q=85&w=1200&auto=format&fit=crop",
    texture:
        "https://images.unsplash.com/photo-1567919915541-dd35562ae895?q=85&w=1600&auto=format&fit=crop",
    founder: "/founder.jpeg",
    founderDesk: "/founder-desk-2.jpeg",
    logo: "/logo.jpeg",
};

export const WHATSAPP_NUMBER = "917970897238";
export const PHONE_DISPLAY = "+91 79708 97238";
export const CONTACT_EMAIL = "hindiganga.learnings@gmail.com";
export const MARQUEE_ITEMS = [
    "Hindi",
    "English",
    "Maths",
    "Science",
    "Coding",
    "K–12 & Adult Learners",
    "1-on-1 & Group Classes",
    "Free Trial Lesson",
];

export const SUBJECTS = [
    {
        id: "hindi",
        name: "Hindi",
        tagline: "Speak, read and write with confidence",
        description:
            "From first words to fluent conversation — reading, writing, grammar and spoken Hindi rooted in culture, for every level.",
        grades: "Beginners to advanced",
        large: true,
        image: "/subject-hindi.jpeg",
    },
    {
        id: "english",
        name: "English",
        tagline: "Language that opens doors",
        description:
            "Reading comprehension, creative writing, grammar and exam technique aligned with your child's school curriculum.",
        grades: "Grades K–12",
        large: false,
        image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?q=85&w=900&auto=format&fit=crop",
    },
    {
        id: "maths",
        name: "Maths",
        tagline: "From number bonds to calculus",
        description:
            "Concept-first teaching that turns maths anxiety into mastery — from early foundations to advanced exam preparation.",
        grades: "Grades K–12",
        large: false,
        image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?q=85&w=900&auto=format&fit=crop",
    },
    {
        id: "science",
        name: "Science",
        tagline: "Curiosity, taught properly",
        description:
            "Physics, chemistry and biology brought to life with experiments, diagrams and plenty of practice.",
        grades: "Grades 3–10",
        large: false,
        image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?q=85&w=900&auto=format&fit=crop",
    },
    {
        id: "coding",
        name: "Coding",
        tagline: "Build the future, line by line",
        description:
            "Python, Scratch and web development through real projects — logic, creativity and problem-solving for young builders.",
        grades: "Ages 7 – 16",
        large: false,
        image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?q=85&w=900&auto=format&fit=crop",
    },
];

export const MANIFESTO = [
    {
        number: "01",
        title: "Rooted in India",
        body: "Our teachers are experienced educators drawn from India's strongest academic traditions — patient, rigorous and deeply invested in every child they teach.",
    },
    {
        number: "02",
        title: "Tuned to your classroom",
        body: "Every lesson aligns with your child's school curriculum — whether that's in the US, Australia, Canada, the UK or anywhere else — so progress at home shows up at school.",
    },
    {
        number: "03",
        title: "Personal, never packaged",
        body: "No pre-recorded videos. Live, one-on-one and small-group sessions with a personal learning plan, regular feedback and honest progress reports for parents.",
    },
];

export const TEACHERS = [
    {
        initials: "RP",
        name: "Rashmi Pandey",
        subjects: "Hindi",
        experience: "7 years of online teaching experience",
        credentials: "M.A. Political Science — Jamshedpur Women's College",
        note: "Makes Hindi feel like home, wherever in the world you are.",
        color: "bg-saffron",
        photo: "/teacher-rashmi.jpeg",
    },
    {
        initials: "RP",
        name: "Rituraj Pandey",
        subjects: "Maths & English",
        experience: "7+ years of online teaching experience",
        credentials: "B.Tech — Electronics & Communication Engineering, Chaibasa Engineering College",
        note: "Turns maths panic into quiet confidence, one concept at a time.",
        color: "bg-teal",
        photo: "/teacher-rituraj.jpeg",
    },
    {
        initials: "RP",
        name: "Ragini Pandey",
        subjects: "Science & Coding",
        experience: "4 years of online teaching experience",
        credentials: "B.Tech — Electronics & Communication Engineering, Chaibasa Engineering College",
        note: "From home experiments to first Python projects — curiosity, taught properly.",
        color: "bg-teal-dark",
        photo: "/teacher-ragini.jpeg",
    },
];

export const PRICING = [
    {
        name: "Group Classes",
        inr: "₹2,000",
        eur: "€22",
        usd: "$24",
        aud: "A$37",
        cad: "C$33",
        unit: "per month",
        description: "Small groups of up to 6 students, matched by level and age.",
        features: ["45-minute live lessons", "Max 6 students per class", "Shared digital whiteboard", "Monthly progress summary", "Free trial lesson included"],
        featured: false,
    },
    {
        name: "One-to-One",
        inr: "₹4,000",
        eur: "€44",
        usd: "$48",
        aud: "A$73",
        cad: "C$66",
        unit: "per month",
        description: "A dedicated teacher, a personal plan, and your child's full attention.",
        features: ["60-minute private lessons", "Personal learning plan", "Scheduling in your time zone", "Detailed report after every lesson", "Free trial lesson included"],
        featured: true,
    },
    {
        name: "Coding Studio",
        inr: "₹4,500",
        eur: "€50",
        usd: "$54",
        aud: "A$82",
        cad: "C$74",
        unit: "per month",
        description: "Project-based coding, from Scratch to Python and the web.",
        features: ["60-minute project lessons", "Portfolio of real projects", "One-to-one or pair format", "Termly showcase for parents", "Free trial lesson included"],
        featured: false,
    },
];

export const TESTIMONIALS = [
    {
        quote: "My daughter went from refusing Hindi at home to reading her grandmother letters. The patience of these teachers is something else.",
        name: "Meera P.",
        meta: "Parent, New Jersey, USA — Grade 5 Hindi",
    },
    {
        quote: "We tried three tutoring services before this. The one-to-one maths lessons here achieved more in a term than a year elsewhere.",
        name: "James W.",
        meta: "Parent, Sydney, Australia — Middle school Maths",
    },
    {
        quote: "My son built his own game in Python within two months. He counts down the days to his coding lesson every single week.",
        name: "Sarah K.",
        meta: "Parent, Toronto, Canada — Coding, age 11",
    },
];

export const YEAR_GROUPS = [
    "Early Years (Ages 4–6)",
    "Elementary / Primary (Ages 6–11)",
    "Middle School (Ages 11–14)",
    "High School (Ages 14–18)",
    "Adult learner",
];
